import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useProfessions() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post(
      "support-extra/dashboard/ListarProfesiones.php",
      {
        token: userData.token,
      }
    );
    setList([...response.map((e) => ({ id: e, text: e }))]);
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
